const requestUrl = "/wp-json/mz-api/v1/";

// var requestUrl;
// if( $("body").is(".postid-17306, .postid-17017, .postid-17018, .postid-17019, .postid-17365, .postid-17370, .postid-17369, .postid-17383") ) {
//     requestUrl = "/wp-json/mz-api/v1/";
//     console.log("Request: STG");
// } else {
//     requestUrl = "https://www.nuasset.nu/wp-json/mz-api/v1/";
//     console.log("Request: PRD");
// }


// RESUME
function addSeparatorsNF(nStr, inD, outD, sep) {
    nStr += "";
    var dpos = nStr.indexOf(inD);
    var nStrEnd = "";
    if (dpos != -1) {
        nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
        nStr = nStr.substring(0, dpos);
    }
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(nStr)) {
        nStr = nStr.replace(rgx, "$1" + sep + "$2");
    }
    return nStr + nStrEnd;
}

function getFundsResume(fundsList) {
    axios
        .get(requestUrl + "funds/resume")
        .then(function (response) {
            var resumeData = response.data;
            // console.log(resumeData)
            for (let index = 0; index < fundsList.length; index++) {
                const element = fundsList[index];
                const elementFind = resumeData.find((item) => item.id == element.apiCode);

                var fundPL = new Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(elementFind.resume.fundNW);

                document.querySelector("." + element.selector + " td.date").innerHTML = moment(new Date(elementFind.resume.date)).format("DD/MM/YYYY");
                // document.querySelector("." + element.selector + " td.cota").innerHTML = str_replace(".", ",", elementFind.resume.fundQuota);
                document.querySelector("." + element.selector + " td.cota").innerHTML = elementFind.resume.fundQuota;
                document.querySelector("." + element.selector + " td.dia").innerHTML = elementFind.resume.fundDay;
                document.querySelector("." + element.selector + " td.mes").innerHTML = elementFind.resume.fundMonth;
                document.querySelector("." + element.selector + " td.ano").innerHTML = elementFind.resume.fundYear;
                document.querySelector("." + element.selector + " td.month12").innerHTML = elementFind.resume.fund12M;
                document.querySelector("." + element.selector + " td.inicio").innerHTML = elementFind.resume.fundFromStart;
                document.querySelector("." + element.selector + " td.pl").innerHTML = fundPL;
                if ($("." + element.accordion + " p.patrimonio").length > 0) {
                    document.querySelector("." + element.accordion + " p.patrimonio").innerHTML = fundPL;
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

function getindexResume(output, indexApiCode) {
    axios
        .get(requestUrl + "indexes/resume")
        .then(function (response) {
            var indexList = response.data;
            // console.log(indexList)
            if (indexApiCode != "") {
                for (let index = 0; index < indexList.length; index++) {
                    if (indexApiCode == indexList[index].id) {
                        const elementName = indexList[index].label;
                        const element = indexList[index].resume;
                        // console.log('12M:'+ element.quota12M+'Day:'+element.day, element.month, element.year+'Date:'+element.date)
                        $('#' + output).append(`
                            <tr>
                                <td style="text-align: left;" class="title">
                                    <span title="${elementName}">${elementName}</span>
                                </td>
                                <td></td>
                                <td>${moment(new Date(element.date)).format("DD/MM/YYYY")}</td>
                                <td class="text-center">-</td>
                                <td>${element.day}</td>
                                <td>${element.month}</td>
                                <td>${element.year}</td>
                                <td>${element.quota12M}</td>
                                <td class="benchmark-start">-</td>
                                <td class="text-center pl">-</td>
                            </tr>
                        `);
                    }
                }
            } else {
                for (let index = 0; index < indexList.length; index++) {
                    // if (indexList[index].id != "609ed984a1f6a30016dce849" && indexList[index].id != "60ae4c784636e7001635fa10" && indexList[index].id != "60b01e410aba6d0016ed808b") {
                    const elementName = indexList[index].label;
                    const element = indexList[index].resume;
                    // console.log(element,elementName)
                    $('#' + output).append(`
                            <tr>
                                <td>${elementName}</td>
                                <td>${moment(new Date(element.date)).format("DD/MM/YYYY")}</td>
                                <td>${element.day}</td>
                                <td>${element.month}</td>
                                <td>${element.year}</td>
                                <td class="cdi-12M">${element.quota12M}</td>
                            </tr>
                        `);
                    // }
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

export function getResumeIndex(output, indexApiCode) {
    axios
    .get(requestUrl + "funds/resume")
    .then(function (response) {
        const data = response.data;
        const item = data.find(e => e.id === indexApiCode);

        const fundPL = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(item.resume.fundNW)

        const fundQuota = item.resume.fund === 'NUIF11' ? 
            new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
            }).format(item.resume.fundQuota)
        : 
            item.resume.fundQuota;

        const fomatedDate = moment(new Date(item.resume.date)).format('DD/MM/YYYY');

        $('#' + output + "_ticker").html(`
            <td>${item.resume.fund}</td>
            <td>${fomatedDate}</td>
            <td>${fundQuota}</td>
            <td>${item.resume.fundDay}</td>
            <td>${item.resume.fundMonth}</td>
            <td>${item.resume.fundYear}</td>
            <td>${item.resume.fund12M !== "0,00%" ? item.resume.fund12M : ""}</td>
            <td>${item.resume.fundFromStart}</td>
            <td>${fundPL}</td>
        `);

        const formatedDateForIndexes =  item.resume.date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$1-$2');

        axios
        .get(requestUrl + "indexes/resume-day", {
            params: { date: formatedDateForIndexes }
        }).then(function (response) {
            const data = response.data;
            const stringName = $("body").hasClass("postid-17383") ? "IMA-B" : "CDI";
            // 17383 = NUIF11

            const item = data.find(e => e.name === stringName);

            const fomatedDateIndice = moment(new Date(item.resume.date)).format('DD/MM/YYYY');

            let intervalId = setInterval(async () => {       
                if (index_accumulated_value !== undefined && index_accumulated_value !== null) {
                    $('#' + output + "_index").html(`
                        <td>${item.label}</td>
                        <td>${fomatedDateIndice}</td>
                        <td></td>
                        <td>${item.resume.day}</td>
                        <td>${item.resume.month}</td>
                        <td>${item.resume.year}</td>
                        <td>${item.resume.quota12M}</td>
                        <td>${index_accumulated_value}</td>
                        <td></td>
                    `);
                    
                    clearInterval(intervalId);
                }
            }, 1000);
        })
        .catch(function (error) {
            console.log(error);
        });
    })
    .catch(function (error) {
        console.log(error);
    });
}

// CHART
function addTimestampToSeries(xAxis, data) {
    for (let index = 0; index < data.length; index++) {
        data[index] = [xAxis[index], data[index]];
    }
    return data;
}
var index_accumulated_value;

export function getChartHistory(chartSelector, fundApiCode, filterPeriodChart, isFirstLoad) {
    if (filterPeriodChart === "all") {
        var url = requestUrl + `funds/${fundApiCode}/profitability`;
    } else {
        const today = new Date();

        today.setMonth(today.getMonth() - parseInt(filterPeriodChart));

        const dataInicio = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
        const dataFim = `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`;    

        var url = requestUrl + `funds/${fundApiCode}/profitability?filters[dataInicio]=${dataInicio}&filters[dataFim]=${dataFim}`;
    }
    axios
        .get(url)
        .then(function (response) {
            var series = response.data.series;
            var xAxis = response.data.xAxisCategories;

            for (let index = 0; index < xAxis.length; index++) {
                var timestamp = xAxis[index];
                xAxis[index] = new Date(timestamp).getTime();
            }

            series[0].data = addTimestampToSeries(xAxis, series[0].data);
            series[1].data = addTimestampToSeries(xAxis, series[1].data);

            renderChart(series, chartSelector, filterPeriodChart, isFirstLoad);

            if( isFirstLoad ) {
                if (series[1]) {
                    index_accumulated_value = series[1].data[series[1].data.length - 1];
                    index_accumulated_value = index_accumulated_value[1].toFixed(2).replace('.', ',') + "%";
                }
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

function renderChart(series, chartSelector, filterPeriodChart, isFirstLoad = false) {
    // $(`[data-loading='${chartSelector}']`).hide();
    $(`[data-loading-filter='${chartSelector}']`).show();

    var siteLang = document.querySelector("html").getAttribute("lang");

    if (siteLang == "pt-br") {
        moment.locale("pt-br");
        Highcharts.setOptions({
            lang: {
                months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                decimalPoint: ",",
                thousandsSep: ".",
            },
        });
        var langChart = true;
    }

    series = series.map(function(serie) {
        serie.name = serie.name.toUpperCase();
        return serie;
    });

    Highcharts.stockChart(chartSelector, {
        navigator: {
            enabled: false
        },
        legend: {
            enabled: true,
            itemStyle: {
                color: '#C8C8C8',
                fontWeight: '500',
            }
        },
        credits: { enabled: false },
        rangeSelector: { enabled: false },
        colors: ["#bd0fea", "#B7B7B7"],
        scrollbar: { enabled: false },
        series: series,

        xAxis: {
            gridLineWidth: 0.1, 
            lineColor: "rgba(255, 255, 255, 0.2)",
            labels: {
                style: {
                    color: '#C8C8C8', 
                },
            },
        },

        yAxis: {
            gridLineWidth: 0.1, 
            lineColor: "rgba(255, 255, 255, 0.2)",
            labels: {
                align: "left",
                formatter: function () {
                    return (this.value < 0 ? "" : "") + this.value + "%";
                },
                style: {
                    color: '#C8C8C8',
                },
            },
            plotLines: [
                {
                    value: 0,
                    width: 1,
                    color: "rgba(255, 255, 255, 0.2)",
                },
            ],
        },

        chart: {
            zoomType: "",
            backgroundColor: "rgba(0,0,0,0)",
            borderColor: "rgba(255, 255, 255, 0.1)",
            plotBorderColor: "rgba(255, 255, 255, 0.1)",
            plotBorderWidth: 1,
            height: 600,
            events: {
                load: function () {
                    if (filterPeriodChart === "all") {
                        var points = this.series[1].points;
                        var finalValue = points[points.length - 1].y;
                        $("td.benchmark-start").html(
                            finalValue.toLocaleString(lang, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            }) + "%"
                        );
                    }
                },
            },
        },

        plotOptions: {
            series: {
                showInNavigator: false,
                dataGrouping: {
                    enabled: false,
                },
            },
        },

        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b>',
            valueDecimals: 2,
            dateTimeLabelFormats: {
                day: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                hour: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                millisecond: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                minute: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                month: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                second: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                week: langChart ? "%e de %B de %Y" : "%B %e, %Y",
                year: langChart ? "%e de %B de %Y" : "%B %e, %Y",
            },
        },
    });

    if (isFirstLoad) {
        if (series[0].data.length < 251) {
            $(`[data-graphic='${chartSelector}'][data-period='12']`).addClass('d-none');
            $(`[data-graphic='${chartSelector}'][data-period='24']`).addClass('d-none');
            $(`[data-graphic='${chartSelector}'][data-period='36']`).addClass('d-none');
        } else if (series[0].data.length < 500) {
            $(`[data-graphic='${chartSelector}'][data-period='24']`).addClass('d-none');
            $(`[data-graphic='${chartSelector}'][data-period='36']`).addClass('d-none');
        } else if (series[0].data.length < 749) {
            $(`[data-graphic='${chartSelector}'][data-period='all']`).addClass('d-none');
        }
    }
}

// FUNDS INTERNAL
function getFundInfoChart(fundId) {
    var url = requestUrl + "funds/" + fundId + "/profitability";

    $.get(url, function (data) {
        // CRIAR FUNÇÃO EXTRACTDATA - PARA EXTRAIR OS DADOS E NÃO REPETIR CÓDIGO
        var fundData = data.quotas[0].data;
        var fundDataArr = [];
        for (let index = 0; index < fundData.length; index++) {
            const element = fundData[index];
            fundDataArr.push({
                x: new Date(element.date).getTime(),
                y: element.fromStart,
            });
        }

        var benchmarkData = data.indexes[0].data;
        var benchmarkDataArr = [];
        for (let index = 0; index < benchmarkData.length; index++) {
            const element = benchmarkData[index];
            benchmarkDataArr.push({
                x: new Date(element.date).getTime(),
                y: element.fromStart,
            });
        }

        console.log("init chart");

        Highcharts.stockChart("chart-" + fundId, {
            title: { text: "" },
            chart: {
                backgroundColor: null,
                events: {
                    load: function () {
                        var points = this.series[0].points;
                        console.log("last:: ", points[points.length - 1]);
                        // points[points.length - 1].update({
                        //     marker: {
                        //         enabled: true
                        //     }
                        // });
                    },
                },
            },
            credits: { enabled: false },
            subtitle: { text: "" },
            rangeSelector: { enabled: false },
            navigator: { enabled: false },
            exporting: { enabled: false },
            scrollbar: { enabled: false },

            yAxis: {
                opposite: false,
                labels: {
                    formatter: function () {
                        return this.value + "%";
                    },
                    style: {
                        fontSize: "13px",
                    },
                },
            },

            legend: {
                enabled: true,
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
            },

            tooltip: {
                valueDecimals: 2,
                valueSuffix: "%",
                xDateFormat: "%d/%m/%Y",
                formatter: function () {
                    var d = new Date(this.x);
                    var s = "";
                    $.each(this.points, function (i, point) {
                        s += '<span style = "color:' + point.series.color + ';">' + point.series.name + " </span>" + " : <strong>" + point.y.toFixed(2) + "%</strong><br />";
                    });
                    s += "<span>" + Highcharts.dateFormat("%d/%m/%Y", this.x) + "</span><br />";
                    return s;
                },
            },

            series: [
                {
                    name: data.quotas[0]._id,
                    data: fundDataArr,
                    type: "area",
                    turboThreshold: 10000,
                    color: "#003963",
                    fillOpacity: 0,
                },
                {
                    name: data.indexes[0]._id,
                    data: benchmarkDataArr,
                    type: "area",
                    turboThreshold: 10000,
                    color: "#8D9091",
                    fillOpacity: 0,
                },
            ],
        });
    });
}

function copyToClipboard(text) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
}

// $(document).ready(function () {
//     var firstFundOpened = $(".fundsCategory__tabs > div.active").attr("data-apiCode");
//     getFundInfoChart(firstFundOpened);

//     // Open Disclaimer modal
//     $(".js-trigger-disclaimerModal").click(function (e) {
//         e.preventDefault();
//         $(".js-target-disclaimerModal").addClass("active");
//         $("body").addClass("noScroll");
//     });
//     $(".js-shutdown-disclaimerModal").click(function () {
//         $(".js-target-disclaimerModal").removeClass("active");
//         $("body").removeClass("noScroll");
//     });

//     // Documents
//     $(".icon-copy").click(function () {
//         copyToClipboard($(this).attr("data-url"));
//     });

//     $(".icon-download").click(function () {
//         window.open($(this).attr("data-url"), "_blank");
//     });
// });